<template>
  <div
    id="common_menu"
    class="common-menu"
    :class="commonMenuOpen && 'common-menu__top'"
  />
</template>

<script>

import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { initCommonMenu, createCommonMenuLoader } from './api'

@Component
class CommonMenu extends Vue {
  @State(s => s.ui.commonMenuOpen) commonMenuOpen

  beforeCreate () {
    if (!window.GS || !window.GS.CommonMenu) {
      createCommonMenuLoader()
    }
  }

  async mounted () {
    try {
      await initCommonMenu()
    } catch (e) {
      Logger.error(e)
    }
  }
}

export default CommonMenu
</script>
<style lang="scss">
.common-menu {
  position: fixed;
  transform: translateY(-37px);
  transition: transform .2s linear;
  width: 100%;
  z-index: 11;
  .window-lock & {
    left: auto;
    right: calc(-1 * var(--scroll-bar-gap-x));
  }

  @include media_tablet {
    position: relative;
    transform: translateY(0);
    transition: none;
  }
  &__top {
    transform: translateY(0);
  }
}
</style>
